var map = {
	"./asscher@2x.png": 303,
	"./cushion@2x.png": 304,
	"./emerald@2x.png": 305,
	"./heart@2x.png": 306,
	"./marquise@2x.png": 307,
	"./oval@2x.png": 308,
	"./pear@2x.png": 309,
	"./princess@2x.png": 310,
	"./radiant@2x.png": 311,
	"./round@2x.png": 312,
	"./trilliant@2x.png": 313
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1371;



//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images ^\.\/.*@2x\.png$
// module id = 1371
// module chunks = 0